import React from "react";
import { Link } from "react-router-dom";
import { SITE } from "@/lib/config";

/**
 * Cláusula RGPD reducida para formularios.
 *  - variant="contact"   → formulario de contacto general.
 *  - variant="member"    → formulario de alta como socio.
 *
 * Se combina con `PrivacyCheckbox` (casilla obligatoria).
 */
export default function PrivacyClause({ variant = "contact" }) {
    const finalidad =
        variant === "member"
            ? "gestionar tu solicitud de adhesión como asociado de ASATTA, mantener la relación asociativa y remitirte comunicaciones informativas relacionadas con la asociación."
            : "atender la consulta o petición que nos remites y, en su caso, mantener el contacto contigo por el medio que hayas indicado.";

    const base =
        variant === "member"
            ? "la adopción de medidas precontractuales a petición del interesado y, en su caso, la ejecución de la relación asociativa (art. 6.1.b RGPD), así como el interés legítimo de la asociación en su gestión (art. 6.1.f RGPD)."
            : "el consentimiento del interesado prestado al enviar el formulario (art. 6.1.a RGPD).";

    return (
        <div
            data-testid={`privacy-clause-${variant}`}
            className="mt-2 text-xs text-[#4A5568] leading-relaxed border border-[#E2E4E9] bg-[#F8F9FA] p-4"
        >
            <p className="font-semibold text-[#082050] mb-2">
                Información básica sobre protección de datos
            </p>
            <ul className="space-y-1">
                <li>
                    <strong>Responsable:</strong> {SITE.fullName} (ASATTA).
                </li>
                <li>
                    <strong>Finalidad:</strong> {finalidad}
                </li>
                <li>
                    <strong>Legitimación:</strong> {base}
                </li>
                <li>
                    <strong>Destinatarios:</strong> no se cederán datos a terceros salvo obligación legal.
                </li>
                <li>
                    <strong>Derechos:</strong> acceso, rectificación, supresión,
                    oposición, limitación y portabilidad, escribiendo a{" "}
                    <a href={`mailto:${SITE.email}`} className="underline">
                        {SITE.email}
                    </a>
                    .
                </li>
                <li>
                    <strong>Información adicional:</strong> consulta la{" "}
                    <Link to="/politica-de-privacidad" className="underline">
                        Política de Privacidad
                    </Link>{" "}
                    completa.
                </li>
            </ul>
        </div>
    );
}
